export const DEADLINE_PROPERTY_MAP = {
  app_deadline: "formattedApplicationDeadline",
  application: "formattedApplicationDeadline",
  registration: "formattedEnrollmentDeadline",
  reg_deadline: "formattedEnrollmentDeadline",
  enrollment: "formattedEnrollmentDeadline",
} as const;

export const APPLY_NOW_URL = "/apply-now";

export const COUPON_AMOUNT_TYPE = {
  CURRENCY: "currency",
  PERCENTAGE: "percentage",
} as const;

export const COUPON_TYPE = {
  PROMOTIONAL: "promotional",
  FULL_SCHOLARSHIP: "fullScholarship",
  PARTIAL_SCHOLARSHIP: "partialScholarship",
} as const;

export const CART_STATUS = {
  READY: "ready",
  COMPLETE: "complete",
  CANCELED: "canceled",
} as const;
